import { render } from "./InputImageFileMobile.vue?vue&type=template&id=4fc42693&scoped=true&ts=true"
import script from "./InputImageFileMobile.vue?vue&type=script&lang=ts"
export * from "./InputImageFileMobile.vue?vue&type=script&lang=ts"

import "./InputImageFileMobile.vue?vue&type=style&index=0&id=4fc42693&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc42693"]])

export default __exports__